import { render, staticRenderFns } from "./SkuTable.vue?vue&type=template&id=5aee559c&scoped=true&"
import script from "./SkuTable.vue?vue&type=script&lang=js&"
export * from "./SkuTable.vue?vue&type=script&lang=js&"
import style0 from "./SkuTable.vue?vue&type=style&index=0&id=5aee559c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee559c",
  null
  
)

export default component.exports